import React, { useState } from "react";
import { toast } from "react-toastify";
import CustomTextField from "../components/CustomTextField";
import CustomButton from "../components/CustomButton";
import { validatePhoneNumber, validatePassword } from "../util/validation";
import { useNavigate } from "react-router-dom";
import { useLoginApi } from "../api/login";

export default function ForgotPasswordPage() {
  const navigate = useNavigate();

  // ✅ API hook
  const { sendResetOtp, resetPassword, resendOtp } = useLoginApi();

  const [step, setStep] = useState(1);
  const [mobile, setMobile] = useState("");
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [loading, setLoading] = useState(false);

  /* ===============================
     STEP 1 → SEND OTP
  =============================== */
  const handleSendOtp = async (e) => {
    e.preventDefault();

    // ✅ Validate phone number
    if (!validatePhoneNumber(mobile)) {
      toast.error("Enter valid 10 digit mobile number");
      return;
    }

    try {
      setLoading(true);

      await sendResetOtp(mobile);

      toast.success("OTP sent to your mobile");
      setStep(2);
    } catch (err) {
      toast.error(err.message || "Failed to send OTP");
    } finally {
      setLoading(false);
    }
  };

  /* ===============================
     RESEND OTP
  =============================== */
  const handleResendOtp = async () => {
    if (!mobile) return;

    try {
      setLoading(true);

      await resendOtp(mobile);

      toast.success("OTP resent successfully");
    } catch (err) {
      toast.error(err.message || "Failed to resend OTP");
    } finally {
      setLoading(false);
    }
  };

  /* ===============================
     STEP 2 → RESET PASSWORD
  =============================== */
  const handleResetPassword = async (e) => {
    e.preventDefault();

    // ✅ Validate OTP
    if (!otp || otp.length !== 6) {
      toast.error("Enter valid 6 digit OTP");
      return;
    }

    // ✅ Validate password (8+ chars)
    if (!validatePassword(newPassword)) {
      toast.error(
        "Password must be at least 8 characters with one letter and one number"
      );
      return;
    }

    try {
      setLoading(true);

      // Backend validates OTP + updates password
      await resetPassword(mobile, otp, newPassword);

      toast.success("Password reset successful");
      navigate("/");
    } catch (err) {
      toast.error(err.message || "Reset failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-wrap">
      <div className="auth-card">

        {/* LEFT PANEL */}
        <div className="auth-left">
          <div className="brand-title">JS AGRO</div>
          <div className="brand-sub">PASSWORD RECOVERY</div>
        </div>

        {/* RIGHT PANEL */}
        <div className="auth-right">

          {/* STEP 1 → ENTER MOBILE */}
          {step === 1 && (
            <form onSubmit={handleSendOtp} className="login-form">
              <h3>Forgot Password</h3>

              <CustomTextField
                label="Registered Mobile Number"
                value={mobile}
                numericOnly
                onChange={(e) => setMobile(e.target.value)}
                placeholder="Enter mobile number"
                required
              />

              <button className="btn-sign" type="submit" disabled={loading}>
                {loading ? "Sending..." : "Send OTP"}
              </button>

              <div className="forgot-link">
                <span onClick={() => navigate("/")}>
                  Back to Login
                </span>
              </div>
            </form>
          )}

          {/* STEP 2 → OTP + NEW PASSWORD */}
          {step === 2 && (
            <form onSubmit={handleResetPassword} className="login-form">
            <h3>Verify OTP & Reset Password</h3>

            <CustomTextField
              label="OTP"
              value={otp}
              numericOnly
              onChange={(e) => setOtp(e.target.value)}
              placeholder="Enter 6 digit OTP"
              required
            />

            <CustomTextField
              label="New Password"
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              placeholder="Enter new password"
              required
            />

            <CustomButton type="submit" className="btn-sign" disabled={loading}>
              {loading ? "Processing..." : "Reset Password"}
            </CustomButton>

        <div className="forgot-actions">
          <span onClick={() => navigate("/")}>
            Back to Login
          </span>

          <span onClick={handleResendOtp}>
            Resend OTP
          </span>
        </div>
          </form>
          )}

        </div>
      </div>
    </div>
  );
}